module.exports = __webpack_public_path__ + "img/weddingbox.30e340f.jpg";